module.exports = __webpack_public_path__ + "img/icon_map_zzsw.e2ab8ae0.png";